<template>
    <div :class="['lessons-list-item', 'text-center', color]">
        <router-link :to="'/lesson/' + lesson.id">
            <i v-if="color === 'green'" class="fa fa-check mr-2"></i>
            <i v-if="color === 'orange'" class="fa fa-pencil-alt mr-2"></i>
            <i v-if="color === 'gray'" class="fa fa-stop-circle mr-2"></i>
            <span>Lesson {{lesson.numberText}}</span> {{lesson.name}}
        </router-link>
    </div>
</template>

<script>
    export default {
        name: "LessonNavItem",
        props: ['lesson', 'color'],
    }
</script>

<style src="@/assets/poliglotiki/main.css">
</style>
